export default __webpack_public_path__ + "static/media/pic5.682f9e7c.jpg";